import {ReactNode} from 'react';

import {Typography} from '@mui/material';

import {selectableCardColors} from './WorkforceProfileWizard.colors';
import {EmpionButton} from '../../../../../components/EmpionButton/EmpionButton';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {accent} from '../../../../../layouts/theme/designSystem';

export interface Props {
  icon: ReactNode;
  title: string;
  description: string;
  selectLabel: string;
  onSelect: () => void;
}

export const WorkforceProfileWizardSelectableCard = ({
  icon,
  title,
  description,
  selectLabel,
  onSelect,
}: Props) => {
  const selectableCardSx = {
    flex: 1,
    minWidth: 0,
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    cursor: 'pointer',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    border: `1px solid ${selectableCardColors.border}`,
    bgcolor: selectableCardColors.surface,
    '&:hover': {
      borderColor: accent.main,
      boxShadow: `0 0 0 1px ${accent.main}`,
    },
  };

  return (
    <EmpionPaper sx={selectableCardSx} onClick={onSelect}>
      {icon}
      <Typography variant='subtitle1' sx={{fontWeight: 600}}>
        {title}
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{flex: 1, lineHeight: 1.6}}>
        {description}
      </Typography>
      <EmpionButton
        variant='secondary'
        onClick={(event) => {
          event.stopPropagation();
          onSelect();
        }}
      >
        {selectLabel}
      </EmpionButton>
    </EmpionPaper>
  );
};
